import React from 'react';

import { SimpleIcon, useSvgId } from './icon-utils';

export function EmptyInbox() {
  const clipPathId = useSvgId('empty-inbox-clip');
  const gradientId = useSvgId('empty-inbox-gradient');
  const topFilterId = useSvgId('empty-inbox-top-filter');
  const bottomFilterId = useSvgId('empty-inbox-bottom-filter');
  const topMaskId = useSvgId('empty-inbox-top-mask');
  const bottomMaskId = useSvgId('empty-inbox-bottom-mask');

  return (
    <SimpleIcon fill="none" height="184" viewBoxDimensions="0 0 296 184" width="296">
      <circle cx="164" cy="92" fill="#F5F6FB" r="92" />
      <g clipPath={`url(#${clipPathId})`}>
        <circle cx="164" cy="92" fill="#1A2551" r="92" />
        <circle cx="164" cy="92" fill={`url(#${gradientId})`} fillOpacity="0.2" r="92" />
        <path
          clipRule="evenodd"
          d="M214 31C213.984 35.4128 210.408 38.9852 206 38.9852C210.418 38.9852 214 42.5736 214 47C214.016 42.5872 217.592 39.0148 222 39.0148C217.582 39.0148 214 35.4264 214 31Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.5"
        />
        <path
          clipRule="evenodd"
          d="M138 59C137.954 71.6869 127.674 81.9574 115 81.9574C127.703 81.9574 138 92.274 138 105C138.046 92.3131 148.326 82.0426 161 82.0426C148.297 82.0426 138 71.726 138 59Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.3"
        />
        <path
          clipRule="evenodd"
          d="M174 35C173.992 37.2064 172.204 38.9926 170 38.9926C172.209 38.9926 174 40.7868 174 43C174.008 40.7936 175.796 39.0074 178 39.0074C175.791 39.0074 174 37.2132 174 35Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M104 70C103.992 72.2064 102.204 73.9926 100 73.9926C102.209 73.9926 104 75.7868 104 78C104.008 75.7936 105.796 74.0074 108 74.0074C105.791 74.0074 104 72.2132 104 70Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M122 15C121.992 17.2064 120.204 18.9926 118 18.9926C120.209 18.9926 122 20.7868 122 23C122.008 20.7936 123.796 19.0074 126 19.0074C123.791 19.0074 122 17.2132 122 15Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.4"
        />
        <path
          clipRule="evenodd"
          d="M234 59C233.992 61.2064 232.204 62.9926 230 62.9926C232.209 62.9926 234 64.7868 234 67C234.008 64.7936 235.796 63.0074 238 63.0074C235.791 63.0074 234 61.2132 234 59Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M189 20C188.992 22.2064 187.204 23.9926 185 23.9926C187.209 23.9926 189 25.7868 189 28C189.008 25.7936 190.796 24.0074 193 24.0074C190.791 24.0074 189 22.2132 189 20Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.2"
        />
      </g>
      <g filter={`url(#${topFilterId})`}>
        <rect fill="white" height="51.0563" rx="7.04225" width="250" x="23" y="109" />
        <rect
          height="50.1761"
          rx="6.60211"
          stroke="#D1D1D1"
          strokeOpacity="0.2"
          strokeWidth="0.880282"
          width="249.12"
          x="23.4401"
          y="109.44"
        />
      </g>
      <rect fill="#F1F1F1" height="10.5634" rx="5.28169" width="80.1056" x="59.9688" y="122.204" />
      <rect fill="#F1F1F1" height="10.5634" rx="5.28169" width="159.331" x="59.9688" y="136.289" />
      <circle cx="253.194" cy="134.088" fill="#D9D9D9" r="12.3239" />
      <circle cx="253.194" cy="134.088" r="12.3239" stroke="white" strokeWidth="0.880282" />
      <mask
        height="22"
        id={topMaskId}
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="22"
        x="30"
        y="122"
      >
        <rect fill="#D9D9D9" height="21.1268" width="21.1268" x="30.2109" y="122.204" />
      </mask>
      <g mask={`url(#${topMaskId})`}>
        <path
          d="M39.0133 136.641L35.4922 133.12L36.7246 131.887L39.0133 134.176L44.8232 128.366L46.0556 129.599L39.0133 136.641Z"
          fill="#324A52"
        />
      </g>
      <g filter={`url(#${bottomFilterId})`}>
        <rect fill="white" height="58" rx="8" width="284" x="6" y="83" />
        <rect
          height="57"
          rx="7.5"
          stroke="#D1D1D1"
          strokeOpacity="0.2"
          width="283"
          x="6.5"
          y="83.5"
        />
      </g>
      <rect fill="#F1F1F1" height="12" rx="6" width="91" x="48" y="98" />
      <rect fill="#F1F1F1" height="12" rx="6" width="181" x="48" y="114" />
      <circle cx="267.5" cy="111.5" fill="#D9D9D9" r="14" />
      <circle cx="267.5" cy="111.5" r="14" stroke="white" />
      <mask
        height="24"
        id={bottomMaskId}
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="25"
        x="14"
        y="98"
      >
        <rect fill="#D9D9D9" height="24" width="24" x="14.1953" y="98" />
      </mask>
      <g mask={`url(#${bottomMaskId})`}>
        <path
          d="M24.1953 114.4L20.1953 110.4L21.5953 109L24.1953 111.6L30.7953 105L32.1953 106.4L24.1953 114.4Z"
          fill="#324A52"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="61.6195"
          id={topFilterId}
          width="260.563"
          x="17.7183"
          y="103.718"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1.76056" />
          <feGaussianBlur stdDeviation="1.76056" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_2004_25587" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.64085" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend
            in2="effect1_dropShadow_2004_25587"
            mode="normal"
            result="effect2_dropShadow_2004_25587"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_2004_25587"
            mode="normal"
            result="shape"
          />
        </filter>

        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="70"
          id={bottomFilterId}
          width="296"
          x="0"
          y="77"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_2004_25587" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend
            in2="effect1_dropShadow_2004_25587"
            mode="normal"
            result="effect2_dropShadow_2004_25587"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_2004_25587"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={gradientId}
          x1="181.5"
          x2="172.5"
          y1="-31.5"
          y2="68"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#B114E8" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect fill="white" height="126" transform="translate(72)" width="184" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
